<template>
  <div>
    <v-footer
      class="justify-center"
      :style="getThemeStyle"
      height="40"
      absolute
    >
      <div class="title font-weight-light text--lighten-1 text-center">
        Created By Kenny [076 243 9441 / 081 482 6615 ] &nbsp; | &nbsp; &copy;
        {{ new Date().getFullYear() }} — {{ getAppName }}
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  computed: {
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
  },
};
</script>

<style></style>
